import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import type { FC } from 'react';
import { useState } from 'react';

interface ITabItem {
  label: string;
  isActive: boolean;
  keepAlive?: boolean;
  disabled?: boolean;
}

export const TabItem: FC<ITabItem> = ({ label, isActive, keepAlive, children, disabled }) => {
  const [hasBeenActive, setHasBeenActive] = useState(isActive);
  if (!hasBeenActive && isActive) {
    setHasBeenActive(true);
  }
  if (isActive || (keepAlive && hasBeenActive)) {
    return (
      <div style={{ height: '100%', display: isActive ? 'block' : 'none' }}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </div>
    );
  }

  // Do not render children it item is not active
  return <div style={{ height: '100%', display: isActive ? 'block' : 'none' }} />;
};
